/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import Accordion from './scripts/accordion';
import FormLightbox from './scripts/form-lightbox';
import PageStatus from './scripts/page-status';
import TextMediaGallery from './scripts/text-media-gallery';
import TextReveal from './scripts/text-reveal';
import VideoHandling from './scripts/video-handling';
import LogoMap from './scripts/logomap';
import EventDates from './scripts/event-dates';

const scripts = [
  PageStatus,
  VideoHandling,
  TextMediaGallery,
  FormLightbox,
  Accordion,
  TextReveal,
  LogoMap,
  EventDates
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    // Set global variable to indicate whether motions should be reduced
    window.prefersReducedMotion = !!(
      window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
      window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
    );

    scripts.forEach(script => {
      script.init();
    });
  }
});
